import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import ClearIcon from '@mui/icons-material/Clear';
import DoneIcon from '@mui/icons-material/Done';
import { Button, IconButton, MenuItem, Select } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ClearCard from "../../components/Card/ClearCard";
import ExportExcel from "../../components/ExportExcel/ExportExcel";
import Gantt from "../../components/Gantt/Gantt";
import ImportExcel from "../../components/ImportExcell/ImportExcel";
import TooltipInformationGantt from "../../components/TooltipInformation/TooltipInformationGantt";
import TooltipInformationVerbali from "../../components/TooltipInformation/TooltipInformationVerbali";
import { VerbaliList } from "../../components/Verbale/VerbaliList";
import { Colors } from "../../constants/colors";
import { authContext } from "../../context/auth";
import { getAssignment } from "../../models/assignment";
import { setDelivered } from "../../models/assignment_composition";
import { createTask, deleteTask, listTasks } from "../../models/task";
import {
  createVerbale,
  listVerbaliByAssignmentAndUser,
  updateVerbale
} from "../../models/verbale";
import { TaskCreateDTO } from "../../types/task";
import { VerbaleCreateDTO, VerbaleDTO, VerbaleUpdateDTO } from "../../types/verbale";
import { PATHS } from "../../utils/paths";
import { RoleNames } from "../../utils/roles";
import {
  GanttColumnProps,
  GanttDependenciesProps,
  GanttEndImageProps,
  GanttExpandFiltersProps,
  GanttFilterProps,
  GanttFunctionalProps,
  GanttLegendProps,
  GanttNowProps,
  GanttStyleProps,
  GanttTasksProps,
  TaskDataProps,
} from "../../utils/types/types";

const MakeAssignment = () => {
  //const { tasks } = props;

  //'done','run','await','ready','skipped'
  enum TaskStatus {
    done = "DONE",
    run = "RUNNING",
    pending = "PENDING",
    macroTask = "MacroTask",
    verbale = "Verbale"
  }
  const { user } = useContext(authContext);

  const { assignId } = useParams();

  const pathRole =
    user?.role === RoleNames.PROFESSOR
      ? PATHS.professor
      : user?.role === RoleNames.ADMIN
        ? PATHS.admin
        : PATHS.student;
  const navigateBack = useNavigate();

  const [assignName, setAssignName] = useState<string>("");

  const [original] = useState<boolean>(true);
  const [bloccoRiquadri] = useState<boolean>(false);
  const [criticalPath] = useState<boolean>(false);
  const [ganttTasks, setGanttTasks] = useState<TaskDataProps[]>([]);
  const [excellDataTasks, setExcellDataTasks] = useState<any[]>([]);
  const [allDataTasks, setAllDataTasks] = useState<any[]>([]);

  const [component, setComponent] = useState<boolean>(true);
  const [verbali, setVerbali] = useState<VerbaleDTO[]>([]);


  const [dateCreationVerbale, setDateCreationVerbale] = useState<Date>();
  const [documentCreationVerbale, setDocumentCreationVerbale] = useState<File>();


  const [dateEditVerbale, setDateEditVerbale] = useState<Date>();
  const [documentEditVerbale, setDocumentEditVerbale] = useState<File>();
  const [idEditVerbale, setIdEditVerbale] = useState<string>();

  const [VerbaliPropsInfo, setVerbaliPropsInfo] = useState<
    { id: string, documentName: string, document: any }[]
  >([])

  const [tooltipProps, setTooltipProps] = useState<{ id: string, name: string, x: number, y: number, width: number, height: number, note: string }>({ id: "", name: "", x: 0, y: 0, width: 0, height: 0, note: "" });

  const [tooltipPropsVerbali, setTooltipPropsVerbali] = useState<{ name: string, x: number, y: number, width: number, height: number, documento: any, documentName: string }>({ name: "", x: 0, y: 0, width: 0, height: 0, documento: "", documentName: "" });

  const [hovered, setHovered] = useState<boolean>(false);

  const [showCreateForm, setShowCreateForm] = useState(false); // State variable to control form visibility
  const [showEditForm, setShowEditForm] = useState(false); // State variable to control form visibility
  const [createVerbaleTaskSelectedValues, setCreateVerbaleTaskSelectedValues] = useState<any>([]); // State variable to control form visibility

  const [editVerbaleTaskSelectedValues, setEditVerbaleTaskSelectedValues] = useState<any>([]); // State variable to control form visibility
  const [detailsViewVerbale, setDetailsViewVerbale] = useState<VerbaleDTO | undefined>(undefined);



  const ganttStyle: GanttStyleProps = {
    width: "99%",
    height: `400px`,
    fontSize: 35,
    fontStyle: "Arial",
    lineWidth: 2,
    strokeColor: "lightgray",
    lineHeight: 100,
    bgColor1: "white",
    bgColor2: "#EDEDED",
    //'done','run','await','ready','skipped'
    status: {
      DONE: { color: Colors.tecnologia.default },
      RUNNING: { color: Colors.edilizia.default },
      PENDING: { color: Colors.accademia.default },
      MacroTask: { color: "blue" },
      Verbale: { color: "red" },
    },
  };
  const tasksStyle: GanttTasksProps = {
    tasksColor: {
      originalTime: "lightgray",
      effectiveTime: "blue",
      selected: "black",
      criticalPath: "orange",
    },
    onclickColor: "black",
    tasksHeight: 30,
    taskCorner: 10,
    originalTasks: original,
    effectiveTasks: true,
  };
  const filterStyle: GanttFilterProps = {
    filterMax: 1000,
    filterFontSize: 25,
    filterFontColor: "blue",
    filterFontStyle: "Arial",
    filterSliderDistance: 0,
    filterGanttDistance: 10,
    filterDateDistance: 10,
    filterMarks: false,
    filterHeight: 2,
    filterThumbSize: 20,
    //filterThumbColor: "red",
    //filterTrackColor: "red",
    //filterRailColor: "red",
    //filterStep: 10,
    filterTextN: 4,
    filterLineN: 2,
    filterTextValues: [
      600000 * 6,
      600000 * 6 * 4,
      600000 * 6 * 8,
      600000 * 6 * 12,
      600000 * 6 * 16,
      600000 * 6 * 20,
      600000 * 6 * 24,
      600000 * 6 * 48,
      600000 * 6 * 24 * 7,
    ],
    filterLineValues: [
      600000,
      600000 * 3,
      600000 * 6,
      600000 * 6 * 4,
      600000 * 6 * 8,
      600000 * 6 * 12,
      600000 * 6 * 16,
      600000 * 6 * 20,
      600000 * 6 * 24,
      600000 * 6 * 48,
      600000 * 6 * 24 * 7,
    ],
  };
  const nowStyle: GanttNowProps = {
    nowLineWidth: 2,
    nowLineColor: "blue",
    nowFontStyle: "Arial italic",
    nowFontSize: 30,
    nowTriangleHeight: 30,
    nowTriangleWidth: 40,
    nowText: "Now",
    nowTextMarginTop: 10,
    nowTextMarginBottom: 15,
  };
  const legendStyle: GanttLegendProps = {
    legendCircleRadius: 20,
    legendCircleStrockeWidth: 1,
    legendCircleStrockeColor: "black",
    legendTextColor: "black",
    legendText1: "original",
    legendText2: "effective",
    legendFontStyle: "arial",
    legendFontSize: 10,
    legendMarginTop: 10,
  };
  const endImageStyle: GanttEndImageProps = {
    endImageURL:
      "data:image/png;base64,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",
    endImageHeight: 100,
    endImageWidth: 100,
  };
  const columnStyle: GanttColumnProps = {
    columnHeaderFontStyle: "Arial",
    columnHeaderFontSize: 30,
    columnHeaderFontColor: "blue",
    distanceBetweenText: 250,
  };
  const dependenciesStyle: GanttDependenciesProps = {
    dependenciesWidth: 3,
    dependenciesColor: "blue",
  };
  const expandFiltersStyle: GanttExpandFiltersProps = {
    expandFilterSize: 30,
    expandFilterTextDistance: 10,
    expandFilterColor: "blue",
    expandFilterLineWidth: 4,
  };
  const functional: GanttFunctionalProps = {
    bloccoRiquadri: bloccoRiquadri,

    criticalPath: criticalPath,

    socket: false,

    MouseInTooltip: (id: string, x: number, y: number, width: number, height: number, scrollPosition: number, yStart: number) => {
      const dataTasks = allDataTasks;
      const task = dataTasks.find(task => {
        const taskName = task.name
        return taskName === id;
      });
      const allGanttTask = ganttTasks;
      const verbaleTask = allGanttTask.find(task => {
        const taskName = task.runbookId
        return taskName === id && task.status === TaskStatus.verbale;
      });

      const vebaleInfo = verbaleTask ? VerbaliPropsInfo.find((element: any) => element.id === verbaleTask.runbookId) : undefined;
      if (yStart + y - scrollPosition >= yStart && task) {

        const note = task ? task.note : undefined;

        const newTooltipProps: any =
          { id: task.id, name: id, x: x, y: y + yStart - scrollPosition + 10, width, height: height - 20, note: note }

        if (id !== "" || x !== 0 || y !== 0 || width !== 0 || height !== 0) {
          setTooltipProps(newTooltipProps);
          setTooltipPropsVerbali({ name: "", x: 0, y: 0, width: 0, height: 0, documento: "", documentName: "" })
        }
        if (!hovered)
          setHovered(true)
      }
      else if (yStart + y - scrollPosition >= yStart && verbaleTask && vebaleInfo) {
        const newTooltipProps: any =
          { name: id, x: x, y: y + yStart - scrollPosition + 10, width, height: height - 20, documento: vebaleInfo.document, documentName: vebaleInfo.documentName }

        if (x !== 0 || y !== 0 || width !== 0 || height !== 0) {
          setTooltipPropsVerbali(newTooltipProps);
          setTooltipProps({ id: "", name: "", x: 0, y: 0, width: 0, height: 0, note: "" })
        }
        if (!hovered)
          setHovered(true)
      }
      else {
        setHovered(false)
      }
    },

    MouseOutTooltip: () => {
      setHovered(false)
    },
  };


  const loadTasks = async (assignId: string) => {
    console.log("Loading tasks for assignment", assignId);
    listTasks(assignId)
      .then((res) => {
        const loadedexcellDataTasks: any[] = [];
        res.data.forEach((e: any) => {
          loadedexcellDataTasks.push({
            id: e.id.toString() || "",
            name: e.name.toString() || "",
            note: e.note.toString() || "",
            originalStart: new Date(e.originalStart),
            originalEnd: new Date(e.originalEnd),
            effectiveStart: new Date(e.effectiveStart),
            effectiveEnd: new Date(e.effectiveEnd),
            status: e.status,
            dependencies: e?.dependencies ? e?.dependencies.toString() : "",
            macroTask: e.macroTask ? e.macroTask.toString() : ""
          });
        })
        setAllDataTasks(loadedexcellDataTasks);
        return loadedexcellDataTasks;
      })
      .catch((e) => {
        console.log(e);
        return null;
      })
  }

  const deleteAllTasks = async (assignId: string) => {
    listTasks(assignId)
      .then((res) => {
        res.data.forEach((e: any) => {
          const id = e.id.toString() || "";
          deleteTask(id)
            .then(() => {
              console.log("Task deleted successfully");
            })
            .catch((e) => {
              console.log(e);
            })
        })
      })
      .catch((e) => {
        console.log(e);
      })
  }

  const loadVerbali = async (assignId: string, userId: string) => {
    listVerbaliByAssignmentAndUser(assignId, userId)
      .then((res) => {
        const verbaliList: VerbaleDTO[] = [];
        res.forEach((e: any) => {
          verbaliList.push(e);
        })
        setVerbali(verbaliList);
      })
      .catch((e) => {
        console.log(e);
      })
  }
  const createNewVerbale = async () => {
    if (dateCreationVerbale && documentCreationVerbale && createVerbaleTaskSelectedValues.length > 0) {
      const newVerbale: VerbaleCreateDTO = {
        date: dateCreationVerbale,
        name: documentCreationVerbale.name,
        document: await getBase64(documentCreationVerbale),
        tasks: createVerbaleTaskSelectedValues
      }
      await createVerbale(newVerbale);
      if (assignId && user?.id) {
        try {
          await loadVerbali(assignId, user.id)

          setDocumentCreationVerbale(undefined);
          setDateCreationVerbale(undefined);
          setCreateVerbaleTaskSelectedValues([]);
          setShowCreateForm(false);
        } catch (error) {
          console.log(error);
        }
      }
    }
  }

  const editVerbale = async () => {
    const newVerbale: VerbaleUpdateDTO = {
      date: dateEditVerbale || undefined,
      tasks: editVerbaleTaskSelectedValues
    }

    if (documentEditVerbale) {
      newVerbale.document = await getBase64(documentEditVerbale);
      newVerbale.name = documentEditVerbale.name;
    }

    if (idEditVerbale) {
      await updateVerbale(idEditVerbale, newVerbale)
      if (assignId && user?.id) {
        try {
          await loadVerbali(assignId, user.id)

          setDocumentEditVerbale(undefined);
          setDateEditVerbale(undefined);
          setEditVerbaleTaskSelectedValues([]);
          setShowEditForm(false);
        } catch (e) {
          console.log(e)
        }

      }
    }
  }

  const getBase64 = async (file: File): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }
  useEffect(() => {
    assignId && loadTasks(assignId);
    user?.id && assignId && loadVerbali(assignId, user.id);
  }, [])

  useEffect(() => {
    assignId && loadTasks(assignId);
    user?.id && assignId && loadVerbali(assignId, user.id);
  }, [component])

  useEffect(() => {
    assignId && loadTasks(assignId);
    user?.id && assignId && loadVerbali(assignId, user.id);
  }, [assignId, user?.id])


  useEffect(() => {
    if (excellDataTasks.length <= 0 || !assignId) return;

    const dbTasks: any = [];
    let errorOccurred = false;


    if (allDataTasks) {
      Promise.all(allDataTasks.map(task => deleteTask(task.id)))
        .then(() => {
          console.log("All tasks deleted successfully");

          // Proceed to create new tasks
          const createTasksPromises: any[] = excellDataTasks.map(taskData => {
            const note = taskData.note ? taskData.note.toString() : "";
            const newTask: TaskCreateDTO = {
              name: taskData.runbookId,
              note: note,
              originalStart: new Date(taskData.originalStart),
              originalEnd: new Date(taskData.originalEnd),
              effectiveStart: new Date(taskData.effectiveStart),
              effectiveEnd: new Date(taskData.effectiveEnd),
              status: taskData.status,
              dependencies: taskData.dependencies ? taskData.dependencies.toString() : "",
              assignmentId: assignId || "",
              macroTask: taskData.macroTask ? taskData.macroTask.toString() : ""
            };

            return createTask(newTask)
              .then(createdTask => {
                dbTasks.push(createdTask);
              })
              .catch(error => {
                errorOccurred = true;
                console.error("Error creating task:", error);
                // You might want to handle the error here
              });
          });

          Promise.all(createTasksPromises)
            .then(() => {
              if (!errorOccurred) {
                console.log("All tasks created successfully");
                const newDataTasks = dbTasks.map((task: any) => ({
                  id: task.data.id,
                  name: task.data.name,
                  note: task.data.note,
                  originalStart: new Date(task.data.originalStart),
                  originalEnd: new Date(task.data.originalEnd),
                  effectiveStart: new Date(task.data.effectiveStart),
                  effectiveEnd: new Date(task.data.effectiveEnd),
                  status: task.data.status,
                  dependencies: task.data.dependencies ? task.data.dependencies.toString() : "",
                  macroTask: task.data.macroTask ? task.data.macroTask.toString() : ""
                }));
                setAllDataTasks(newDataTasks);
              } else {
                console.error("One or more tasks failed to create");
                deleteAllTasks(assignId)
                  .then(() => { window.location.reload(); });
                // You might want to handle this case
              }
            })
            .catch(error => {
              deleteAllTasks(assignId)
                .then(() => { window.location.reload(); });
              // You might want to handle this case

            });
        })
        .catch(error => {
          deleteAllTasks(assignId)
            .then(() => { window.location.reload(); });
          console.error("Error deleting tasks:", error);
          // You might want to handle this case
        });
    }
  }, [excellDataTasks]);


  useEffect(() => {


    const loadedGanttTasks: TaskDataProps[] = [];
    const verbaliInfo: any = [];
    const macroTaskMap: Map<string, TaskDataProps[]> = new Map(); // Map to store tasks grouped by macroTask
    allDataTasks.forEach((e: any) => {
      if (!macroTaskMap.has(e.macroTask)) {
        macroTaskMap.set(e.macroTask, []);
      }
      macroTaskMap.get(e.macroTask)?.push({
        runbookId: e.name ? e.name : e.macroTask,
        originalStart: new Date(e.originalStart),
        originalEnd: new Date(e.originalEnd),
        effectiveStart: new Date(e.effectiveStart),
        effectiveEnd: new Date(e.effectiveEnd),
        status: e.status,
        dependencies: e.dependencies.split(",") || [],
        criticalPath: false,
      });
    });

    // Iterate through macroTaskMap to create tasks for each macroTask
    macroTaskMap.forEach((tasks: TaskDataProps[], macroTask: string) => {
      const earliestOriginalStart = new Date(Math.min(...tasks.map(task => task.originalStart.getTime())));
      const latestOriginalEnd = new Date(Math.max(...tasks.map(task => task.originalEnd.getTime())));
      const earliestEffectiveStart = new Date(Math.min(...tasks.map(task => task.effectiveStart.getTime())));
      const latestEffectiveEnd = new Date(Math.max(...tasks.map(task => task.effectiveEnd.getTime())));

      // Create a task for the macroTask
      const macroTaskTask: TaskDataProps = {
        runbookId: macroTask,
        originalStart: earliestOriginalStart,
        originalEnd: latestOriginalEnd,
        effectiveStart: earliestEffectiveStart,
        effectiveEnd: latestEffectiveEnd,
        status: 'MacroTask',
        dependencies: [],
        criticalPath: false,
      };

      loadedGanttTasks.push(macroTaskTask);

      // Add the tasks for the macroTask
      loadedGanttTasks.push(...tasks);
    });
    loadedGanttTasks.sort((a, b) => {
      if (a.effectiveStart.getTime() !== b.effectiveStart.getTime()) {
        return a.effectiveStart.getTime() - b.effectiveStart.getTime();
      }
      else if (a.originalStart.getTime() !== b.originalStart.getTime()) {
        return a.originalStart.getTime() - b.originalStart.getTime();
      }
      else if (a.effectiveEnd.getTime() !== b.effectiveEnd.getTime()) {
        return a.originalEnd.getTime() - b.originalEnd.getTime();
      }
      else {
        return a.originalEnd.getTime() - b.originalEnd.getTime();
      }
    });


    verbali.forEach((verbale, index) => {
      if (verbale.tasks && verbale.tasks.length > 0) {
        const lastVerbaleTask = loadedGanttTasks
          .filter(task => {
            const matchingAllDataTask = allDataTasks.find(dataTask => {

              const isMatching = dataTask.name === task.runbookId && verbale.tasks.some(verbaleTask => verbaleTask.id === dataTask.id);
              return isMatching;
            });
            return matchingAllDataTask !== undefined;
          })
          .reduce((latestTask, currentTask) => {
            return latestTask.effectiveEnd > currentTask.effectiveEnd ? latestTask : currentTask;
          }, loadedGanttTasks[0]);




        // Find the index of the lastVerbaleTask in loadedGanttTasks
        const lastIndex = loadedGanttTasks.findIndex(task => task === lastVerbaleTask);

        // Insert the verbale task after the lastVerbaleTask
        const newVerbaleTaskIndex = lastIndex;
        const newVerbaleTask = {
          runbookId: 'verbale_' + new Date(verbale.date).toLocaleDateString() + "_" + index.toString(),
          originalStart: new Date(verbale.date),
          originalEnd: new Date(verbale.date), // Set the original end same as original start since it's a point task
          effectiveStart: new Date(verbale.date),
          effectiveEnd: new Date(verbale.date),
          status: TaskStatus.verbale,
          dependencies: [],
          criticalPath: false,
        };
        const newVerbaleInfo = {
          id: 'verbale_' + new Date(verbale.date).toLocaleDateString() + "_" + index.toString(),
          documentName: verbale.name,
          document: verbale.document,
        }
        verbaliInfo.push(newVerbaleInfo);
        loadedGanttTasks.splice(newVerbaleTaskIndex + 1, 0, newVerbaleTask);
      }
    });


    setGanttTasks(loadedGanttTasks);
    setVerbaliPropsInfo(verbaliInfo);

  }, [allDataTasks, verbali])

  useEffect(() => {
    if (assignId)
      getAssignment(assignId)
        .then(response => {
          setAssignName(response.data.name);
        })
        .catch(() => {
        })
  }, [assignId]);


  useEffect(() => { console.log(ganttTasks) }, [ganttTasks])


  const toggleForm = () => {
    setShowCreateForm(!showCreateForm);
  };

  const deliverAssignment = (assignId: string, userId: string) => {
    setDelivered(assignId, userId)
      .then(() => {
        navigateBack(pathRole + PATHS.home)
      })
  }

  return (
    <div>
      <IconButton className='text-edilizia-default' onClick={() => navigateBack(pathRole + PATHS.home)}>
        <ArrowCircleLeftOutlinedIcon></ArrowCircleLeftOutlinedIcon>
      </IconButton>
      <div className="font-bold text-tecnologia-default text-[30px] ml-[5%]">
        {assignName}
      </div>
      <div
        className=""
        style={{
          position: "relative",
          width: "99%",
          textAlign: "left",
          top: "30px",
          margin: "auto",
          height: "500px"
        }}
      >
        <div className="h-full items-stretch rounded-3xl border-2 border-edilizia-default pb-4 shadow-sm ">
          <div className="mb-12 relative">
            {" "}
            <div className="block ">
              <div
                className={`inline-block py-2 pl-8 pr-10 hover:cursor-pointerthe status m
                            ${!component ? `bg-white text-edilizia-default rounded-tl-3xl-br-full` : `bg-edilizia-default text-white rounded-tl-2xl-br-full`}  
                             border-b-2 border-r-2 border-edilizia-default`}
                onClick={() => setComponent(true)}
                style={{ position: "relative", zIndex: 2 }}
              >
                Gantt
              </div>
              <button
                className={`absolute rounded-ee-full border-b-2 border-r-2 border-edilizia-default ${component
                  ? ` text-edilizia-default`
                  : `bg-edilizia-default text-white`
                  } pr-8 pl-16 py-2 text-edilizia-default left-[-40px]`}
                onClick={() => setComponent(false)}
                style={{ position: "relative", zIndex: 1 }}
              >
                Verbali
              </button>
            </div>
          </div>

          {component ? (
            <>
              <div className="absolute right-10 top-5 inline-block">
                <div className="inline-block px-4">
                  <ImportExcel setReturn={setExcellDataTasks} color={Colors.edilizia.default}></ImportExcel>
                </div>
                <div className="inline-block">
                  <ExportExcel jsonData={excellDataTasks.length > 0 ? excellDataTasks : allDataTasks} fileName="Sample" color={Colors.edilizia.default}></ExportExcel>
                </div>
              </div>
              <>
                {

                  ganttTasks.length > 0 ? (
                    <Gantt
                      ganttStyle={ganttStyle}
                      tasksStyle={tasksStyle}
                      filterStyle={filterStyle}
                      nowStyle={nowStyle}
                      legendStyle={legendStyle}
                      endImageStyle={endImageStyle}
                      columnStyle={columnStyle}
                      dependenciesStyle={dependenciesStyle}
                      expandFiltersStyle={expandFiltersStyle}
                      functional={functional}
                      tasks={ganttTasks}
                    />
                  ) : (
                    <div className="text-center font-bold text-edilizia-default">
                      Nessuna attività caricata, scarica il template e ricaricalo con le attività
                    </div>
                  )
                }
              </>


              {tooltipProps.name !== "" && <TooltipInformationGantt
                edit={true}
                show={hovered}
                x={113}
                y={tooltipProps.y + 55}
                id={tooltipProps.id}
                name={tooltipProps.name}
                note={tooltipProps.note}
                allDataTasks={allDataTasks}
                updateAllTasks={setAllDataTasks}
              />}
              {tooltipPropsVerbali.name !== "" && <TooltipInformationVerbali
                show={hovered}
                x={113}
                y={tooltipPropsVerbali.y + 55}
                name={tooltipPropsVerbali.name}
                document={tooltipPropsVerbali.documento}
                documentName={tooltipPropsVerbali.documentName}
              />
              }
            </>
          ) : (
            <>
              {showCreateForm ?
                (
                  <div className="sm:w-[400px] top-1/3 text-right m-auto">
                    <IconButton className="sm:right-[-30px]" onClick={() => {
                      setDocumentCreationVerbale(undefined);
                      setDateCreationVerbale(undefined);
                      setCreateVerbaleTaskSelectedValues([]);
                      setShowCreateForm(false);
                    }}>
                      <ClearIcon className='text-tecnologia-default' />
                    </IconButton>
                    <ClearCard title={`Crea Verbale`}>
                      <form onSubmit={(e) => {
                        e.preventDefault();
                        createNewVerbale();
                      }}>
                        <div className=''>
                          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                            <DateTimePicker
                              label="Data"
                              views={['year', 'month', 'day', 'hours', 'minutes']}
                              format="DD/MM/YYYY  HH:mm" // Use formatString prop for custom formatting
                              onChange={(e: Date | null) => {
                                e && setDateCreationVerbale(new Date(e));
                              }}
                            />
                          </LocalizationProvider>
                          <div className="w-full relative">
                            {documentCreationVerbale && <DoneIcon className="absolute right-[50px] my-auto text-4xl text-tecnologia-default"></DoneIcon>}
                            <label htmlFor={`facile_upload_`} className={""}>
                              <div className="w-1/2 mt-4 relative rounded-md hover:cursor-pointer hover:bg-edilizia-disabled bg-edilizia-default text-white p-2 px-0 md:right-1 m-auto"> Carica Documento</div>
                            </label>
                            <input id={`facile_upload_`} className="hidden" type="file" onChange={(event) => {
                              const file = event.target.files?.[0] || undefined;
                              setDocumentCreationVerbale(file)
                            }} />
                          </div>
                          <div className="mt-4 text-tecnologia-default font-bold">Aggiungi tasks</div>
                          <Select
                            className="p-0  border border-edilizia-default w-1/2"
                            multiple
                            value={createVerbaleTaskSelectedValues} // Ensure `value` is always an array
                            onChange={(e) => {
                              const selectedValues = e.target.value; // Get the array of selected values
                              setCreateVerbaleTaskSelectedValues(selectedValues); // Update selected values state
                              // Handle selected values as needed
                            }}
                            inputProps={{ 'aria-label': 'Order By' }}
                            MenuProps={{
                              anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                              },
                              transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                              },
                            }}
                            sx={{
                              boxShadow: 'none',
                              color: Colors.edilizia.default,
                              ".MuiOutlinedInput-notchedOutline": { border: 0 },
                              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                            }} // Remove border
                          >
                            {allDataTasks.map(((task, index) => {
                              return (
                                <MenuItem key={task + index} value={task.id}>{task.name}</MenuItem>)
                            }))
                            }
                          </Select>
                          <div className="text-center p-4">
                            <Button
                              className="bg-gradient-to-r from-accademia-default via-tecnologia-default to-edilizia-default text-white font-bold disabled:from-accademia-disabled disabled:via-tecnologia-disabled disabled:to-edilizia-disabled"
                              size="medium"
                              type="submit"
                              color="info"
                              variant="contained"
                              disabled={!(dateCreationVerbale && documentCreationVerbale && createVerbaleTaskSelectedValues.length > 0)}
                            >
                              CREA
                            </Button>
                          </div>
                        </div>
                      </form>
                    </ClearCard>
                  </div>
                ) : showEditForm ? (
                  <div className="sm:w-[400px] top-1/3 text-right m-auto">
                    <IconButton className="sm:right-[-30px]" onClick={() => {
                      setDocumentEditVerbale(undefined);
                      setDateEditVerbale(undefined);
                      setEditVerbaleTaskSelectedValues([]);
                      setShowEditForm(false);
                    }}>
                      <ClearIcon className='text-tecnologia-default' />
                    </IconButton>
                    <ClearCard title={`Modifica Verbale`}>
                      <form onSubmit={(e) => {
                        e.preventDefault();
                        editVerbale();
                      }}>
                        <div className=''>
                          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                            <DateTimePicker
                              label="Data"
                              defaultValue={dateEditVerbale ? dayjs(dateEditVerbale) : undefined} // Make sure expiration is a dayjs object
                              views={['year', 'month', 'day', 'hours', 'minutes']}
                              format="DD/MM/YYYY HH mm" // Use formatString prop for custom formatting
                              onChange={(e) => {
                                e && setDateEditVerbale(new Date(e.toDate()));
                              }}
                            />
                          </LocalizationProvider>
                          <div className="w-full relative">
                            {documentEditVerbale && <DoneIcon className="absolute right-[50px] my-auto text-4xl text-tecnologia-default"></DoneIcon>}
                            <label htmlFor={`facile_upload_`} className={""}>
                              <div className="w-1/2 mt-4 relative rounded-md hover:cursor-pointer hover:bg-edilizia-disabled bg-edilizia-default text-white p-2 px-0 md:right-1 m-auto"> Carica Documento</div>
                            </label>
                            <input id={`facile_upload_`} className="hidden" type="file" onChange={(event) => {
                              const file = event.target.files?.[0] || undefined;
                              setDocumentEditVerbale(file)
                            }} />
                          </div>
                          <div className="mt-4 text-tecnologia-default font-bold">Aggiungi tasks</div>
                          <Select
                            className="p-0  border border-edilizia-default w-1/2"
                            multiple
                            value={editVerbaleTaskSelectedValues} // Ensure `value` is always an array
                            onChange={(e) => {
                              const selectedValues = e.target.value; // Get the array of selected values
                              setEditVerbaleTaskSelectedValues(selectedValues); // Update selected values state
                              // Handle selected values as needed
                            }}
                            inputProps={{ 'aria-label': 'Order By' }}
                            MenuProps={{
                              anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                              },
                              transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                              },
                            }}
                            sx={{
                              boxShadow: 'none',
                              color: Colors.edilizia.default,
                              ".MuiOutlinedInput-notchedOutline": { border: 0 },
                              "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                              "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                            }} // Remove border
                          >
                            {allDataTasks.map(((task, index) => {
                              return (
                                <MenuItem key={task + index} value={task.id}>{task.name}</MenuItem>)
                            }))
                            }
                          </Select>
                        </div>
                        <div className="text-center p-4">
                          <Button
                            className="bg-gradient-to-r from-accademia-default via-tecnologia-default to-edilizia-default text-white font-bold disabled:from-accademia-disabled disabled:via-tecnologia-disabled disabled:to-edilizia-disabled"
                            size="medium"
                            type="submit"
                            color="info"
                            variant="contained"
                            disabled={editVerbaleTaskSelectedValues.length === 0}
                          >
                            MODIFICA
                          </Button>
                        </div>
                      </form>
                    </ClearCard>
                  </div>
                ) : (
                  verbali.length !== 0 ? (
                    <VerbaliList
                      verbali={verbali}
                      assignId={assignId}
                      setVerbali={setVerbali}
                      detailsViewVerbale={detailsViewVerbale}
                      setDetailsViewVerbale={setDetailsViewVerbale}
                      openEdit={setShowEditForm}
                      editDate={setDateEditVerbale}
                      editIdVerbale={setIdEditVerbale}
                      edit={true}
                    />
                  )
                    : (
                      <div className="text-center text-edilizia-default font-bold">
                        Nessun verbale disponibile, clicca su “AGGIUNGI VERBLE” per inserirne uno
                      </div>
                    )
                )}

              {!showCreateForm && !showEditForm && !detailsViewVerbale && (
                <div className="absolute w-[100%] flex p-8 bottom-0">
                  <Button
                    className="bg-gradient-to-r from-accademia-default via-tecnologia-default to-edilizia-default text-white font-bold disabled:from-accademia-disabled disabled:via-tecnologia-disabled disabled:to-edilizia-disable m-auto"
                    size="medium"
                    color="info"
                    variant="contained"
                    onClick={toggleForm} // Call toggleForm when the button is clicked
                    onKeyUp={toggleForm}
                    sx={{ borderRadius: 0 }}
                  >
                    AGGIUNGI VERBALE
                  </Button>
                </div>
              )}
            </>
          )}

        </div>
        <div className="w-[100%] flex p-8" >
          {user?.role === RoleNames.STUDENT && <Button
            className={`bg-gradient-to-r from-accademia-default via-tecnologia-default to-edilizia-default text-white font-bold disabled:from-accademia-disabled disabled:via-tecnologia-disabled disabled:to-edilizia-disable m-auto`}
            size="medium"
            color="info"
            variant="contained"
            onClick={() => {
              assignId && user.id && deliverAssignment(assignId, user.id)
            }}
            sx={{ borderRadius: 0 }}
            disabled={showCreateForm || showEditForm || detailsViewVerbale ? true : false}
          >
            CONSEGNA ESERCITAZIONE
          </Button>}
        </div>
      </div>


    </div>
  );
};

export default MakeAssignment;
